import React from "react";
import { useNetworkStatus } from "../layout/NetworkStatusProvider";

const ConnectionBanner = () => {
  const isOnline = useNetworkStatus();

  return (
    <div
      style={{
        display: isOnline ? "none" : "block",
        backgroundColor: "red",
        color: "white",
        padding: "10px",
        textAlign: "center",
      }}
    >
      You are offline. Some features may not work.
    </div>
  );
};

export default ConnectionBanner;
